import * as Constants from "../../utils/constants";
import { ICOC_CONTENT_REQUEST, ICOC_CONFIG_REQUEST } from "../../utils/AllInterface";

export const setStofKey = (payload: any) => ({
  type: Constants.SET_STOF_KEY,
  payload
});

export const setSessionInfo = (payload: any) => ({
  type: Constants.SESSION_INFO,
  payload
});

export const setTabName = (payload: any) => ({
  type: Constants.TAB_NAME,
  payload
});

export const updateGpsCoordinates = (data: any) => ({
  type: Constants.UPDATE_GPS_COORDS,
  payload: data
});

export const GetRecent = (data: any) => {
  return {
    type: Constants.GET_RECENT,
    payload: data
  };
};
export function fetchUserDetails(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS,
    payload: data
  };
}
export function fetchUserDetailsNew(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS_NEW,
    payload: data
  };
}
export function validateMobileNumber(data: any) {
  return {
    type: Constants.VALIDATE_MOBILE_NUMBER,
    payload: data
  };
}
export function validateMobileNumberSuccess(data: any) {
  return {
    type: Constants.VALIDATE_MOBILE_NUMBER_SUCCESS,
    data
  };
}
export function validateMobileNumberError(data: any) {
  return {
    type: Constants.VALIDATE_MOBILE_NUMBER_FAILED,
    data
  };
}
export function fetchUserDetailsSuccess(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS_SUCCESS,
    payload: data
  };
}

export function fetchUserDetailFailed(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS_FAILED,
    payload: data
  };
}
export function fetchNewUserDetailsSuccess(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS_NEW_SUCCESS,
    payload: data
  };
}

export function fetchNewUserDetailFailed(data: any) {
  return {
    type: Constants.FETCH_USER_DETAILS_NEW_FAILED,
    payload: data
  };
}

export function registerDeviceToken(data: any) {
  return {
    type: Constants.REGISTER_DEVICE_ACTION,
    payload: data
  };
}

export function registerDeviceResponseAction(data: any) {
  return {
    type: Constants.REGISTER_DEVICE_RESPONSE_ACTION,
    payload: data
  };
}

export const showAlert = (data: any) => {
  return {
    type: Constants.SHOW_ALERT_MESSAGE,
    payload: data
  };
};
export const hideAlert = () => ({
  type: Constants.HIDE_ALERT_MESSAGE,
});

export const getMoreTabContent = (data: any) => ({
  type: Constants.GET_MORE_TAB_CONTENT,
  payload: data
});

export const moreTabContentResponse = (result: any) => ({
  type: Constants.MORE_TAB_CONTENT_RESPONSE,
  payload: result
});

export const homeWebContentResponse = (result: any) => ({
  type: Constants.HOME_WEB_CONTENT_RESPONSE,
  payload: result
});

export const moreTabContentResponseDummy = (result: any) => ({
  type: Constants.MORE_TAB_CONTENT_RESPONSE_DUMMY,
  payload: result
});

export const showNetworkAlert = () => {
  return showAlert({
    isShowAlert: true,
    alertMessage: Constants.PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
    alertTitle: Constants.NO_NETWORK,
  });
};

export const initializeOfflineModule = (userId: any) => ({
  type: Constants.OFFLINE_MODE_START,
  payload: userId
})

export const createOfflineJSON = (data: any) => ({
  type: Constants.CREATE_OFFLINE_JSON,
  payload: data
})

export const getConfigParams = (data: any) => ({
  type: Constants.GET_CONFIG_PARAMS,
  payload: data
})

export const updateOfflineContent = (data: any) => ({
  type: Constants.UPDATE_OFFLINE_CONTENT,
  payload: data
})

export const findSearchData = (data: any) => ({
  type: Constants.FIND_SEARCH_DATA,
  payload: data
})

export const findShipmentInfo = (data: any) => ({
  type: Constants.FIND_SHIPMENT_INFO,
  payload: data
})

export const updateSearchParamsInOfflineJSON = (data: any) => ({
  type: Constants.UPDATE_SEARCH_PARAMS_OFFLINE,
  payload: data
})

export const updateShipmentInfoInOfflineJSON = (data: any) => ({
  type: Constants.UPDATE_SHIPMENT_INFO_OFFLINE,
  payload: data
})

export const updatePullToRefreshState = (data: any) => {
  return {
    type: Constants.UPDATE_PULL_TO_REFRESH_STATE,
    payload: data
  }
}

export const storeAccessToken = (data: any) => ({
  type: Constants.STORE_ACCESS_TOKEN,
  payload: data
})
export const registerUser = (payload: any) => ({
  type: Constants.REGISTER_USER,
  payload
});
export const checkMobileNumberExist = (payload: any) => ({
  type: Constants.REGISTER_CHECK_MOBILE_NUMBER_EXIST,
  payload,
});
export const registerUserStatusMessage = (payload: any) => ({
  type: Constants.REGISTER_USER_STATUS_MESSAGE,
  payload
});

export const clearRegisterUserStatusMessage = () => ({
  type:
    Constants.CLEAR_REGISTER_USER_STATUS_MESSAGE,
});

export const searchByReferenceId = (queryData: any, isHideLoader: boolean, callback?:()=>{}) => ({
  type: Constants.SEARCH_LOAD_BY_REFERENCE_ID,
  payload: {
    queryData,
    isHideLoader,
    callback
  }
});

export const getSearchedLoadById = (data: any) => {
  return {
    type: Constants.SEARCHED_LOAD_BY_ID,
    payload: data
  };
};
export const getUserPreferences = () => ({
  type: Constants.GET_USER_PREFERENCES
});


export const saveUserPreferences = (payload: any) => ({
  type: Constants.SAVE_USER_PREFERENCES,
  payload
});
export const saveUserPreferencesDomain = (payload: any) => ({
  type: Constants.SAVE_USER_PREFERENCES_DOMAIN,
  payload
});
export const UpdatePreferences = (payload: any) => ({
  type: Constants.UPDATE_USER_PREFERENCES,
  payload
});

export const setNavigation = (payload: any) => ({
  type: Constants.SET_NAVIGATION,
  payload
});

export const devicePlatform = (payload: any) => ({
  type: Constants.DEVICE_PLATFORM,
  payload
});

export const SetShowNotification = (payload: any) => ({
  type: Constants.SHOW_NOTIFICATION,
  payload
});

export const SetContentStackApiCalled = (payload: any) => ({
  type: Constants.API_CALLED,
  payload
});

export const getWebNotifications = (payload: any) => ({
  type: Constants.GET_USER_NOTIFICATIONS,
  payload
})

export const setWebNotifications = (payload: any) => ({
  type: Constants.SET_USER_NOTIFICATIONS,
  payload
})

export const updateNotificationBellIconState = (payload: any) => ({
  type: Constants.UPDATE_NOTIFICATION_BELL_ICON,
  payload
})

export const updateStatusofNotification = (payload: any) => ({
  type: Constants.UPDATE_STATUS_USER_NOTIFICATION,
  payload
})

export const updateNewToUnreadNotifications = (payload: any) => ({
  type: Constants.UPDATE_NEW_TO_UNREAD_NOTIFICATION,
  payload
})

export const setDynamicLinkParams = (payload: any) => ({
  type: Constants.SET_DYNAMIC_LINK_PARAMS,
  payload
})
export const deleteDynamicLinkParams = () => ({
  type: Constants.DEEPLINK_CLEANUP,
})

export const termsAndConditionRequest = () => ({
  type: Constants.TERMS_CONDITION_REQUEST,
})
export const uploadDocumentConfigRequest = (payload: Array<ICOC_CONTENT_REQUEST | ICOC_CONFIG_REQUEST>) => ({
  type: Constants.UPLOAD_DOCUMENT_CONFIG_TYPE,
  payload
})